import PropTypes from 'prop-types';

export const VesselType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
});
